<script setup>
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref, watch} from "vue";
import {useSystem} from "../../store/system";
import {useUser} from "../../store/user";
import {defineProps} from 'vue'

const props = defineProps({
  onlyShowBottom: {
    type: Boolean,
    required: true,
    default: false
  }
})

const router = useRouter()
const route = useRoute()
if (route.query.btc) {
  window.localStorage.setItem('mine_src', route.query.btc)
}

const systemStore = useSystem()
//获取系统配置
systemStore.systemInfoApi()
//获取系统设置的模块名称
systemStore.frontModuleListApi()
const website = systemStore.getWebsite

//监听窗口变化
if (window.screen.width <= 1000) {
  systemStore.setIsMobile(true)
}else{
  systemStore.setIsMobile(false)
}
window.addEventListener('resize', () => {
  console.log("窗口变化:", window.innerWidth)
  systemStore.setMenuIsOpen(false)
  let headerBtn = document.querySelector('.header__btn');
  if (headerBtn && headerBtn.classList.contains('header__btn--active')) {
    headerBtn.classList.remove('header__btn--active');
  }
  if (window.innerWidth <= 1000) {
    systemStore.setIsMobile(true)
  }else{
    systemStore.setIsMobile(false)
  }
})

const userStore = useUser()

//判断用户是否处于登录状态
const isLogin = ref(false)

if(userStore.getToken.length > 0 && userStore.getToken !== '') {
  isLogin.value = true
  userStore.updateUserInfoApi()
}

const dashboardOrLogin = () => {
  if (isLogin.value) {
    // 已登录进入个人中心
    router.push({path: '/Dashboard'})
  }else{
    // 未登录进行登录
    router.push({path: '/Signin'})
  }
}

watch(
    () => userStore.getUserInfo, // 监听 invitation_code 变化
    (newValue) => {
      // 点击复制
      systemStore.copyTxt('.copyBtn', userStore.getInviteLink, "copy success!", "copy error!")
    },
    { once: true } // 只监听一次
);


const navigation = [
  {
    name: 'Home',
    href: '/',
    current: true,
    child: [
      // { name: 'Home-Stil v1', href: '/', current: false },
      // { name: 'Home-Stil v2', href: '/Home2', current: false }
    ]
  },
  {
    name: 'Plans',
    href: "/Products",
    current: false,
    child: []
  },
  // {
  //   name: 'Cloud Mining',
  //   href: '#',
  //   current: false,
  //   child: [
  //     { name: 'Invest', href: '/Invest', current: false },
  //     { name: 'Token', href: '/Token', current: false },
  //     { name: 'Affiliate', href: '/Affiliate', current: false },
  //     { name: 'Contest', href: '/Contest', current: false },
  //   ]
  // },
  {
    name: 'Become Promoter',
    href: '/Contest',
    current: false,
    child: [
      // { name: 'Daily Rewards', href: '/DailyRewards', current: false },
      // { name: 'Become Promoter', href: '/BecomePromoter', current: false },
    ]
  },
  {
    name: 'About',
    href: '/About',
    current: false,
    child: []
  },
  {
    name: 'News',
    href: '/Blog',
    current: false,
    child: []
  },
  {
    name: 'App',
    href: '/App',
    current: false,
    child: []
  },
  {
    name: 'FAQ',
    href: '/Faq',
    current: false,
    child: []
  },
  // {
  //   name: 'Contacts',
  //   href: '/Contacts',
  //   current: false,
  //   child: []
  // },
  // {
  //   name: 'News',
  //   href: '/Blog',
  //   current: false,
  //   child: []
  // },
  // {
  //   name: 'Pages',
  //   href: '#',
  //   current: false,
  //   child: [
  //     { name: 'How', href: '/How', current: false },
  //     { name: 'Reports', href: '/Reports', current: false },
  //     { name: 'Profile', href: '/Profile', current: false },
  //     { name: 'Article', href: '/Article', current: false },
  //     { name: 'Contacts', href: '/Contacts', current: false },
  //     { name: 'FAQ', href: '/Faq', current: false },
  //   ]
  // },
  // {
  //   name: '...',
  //   href: '#',
  //   current: false,
  //   child: [
  //     { name: 'Signin', href: '/Signin', current: false },
  //     { name: 'Signup', href: '/Signup', current: false },
  //     { name: 'Forgot', href: '/Forgot', current: false },
  //     { name: '404', href: '/404', current: false },
  //     { name: 'Privacy', href: '/Privacy', current: false },
  //   ]
  // },
]

const currentLang = ref(Cookies.get('googtrans_name') && Cookies.get('googtrans_name') != 'null'? Cookies.get('googtrans_name'): 'English')
// const langList = [
//   {name: "Englisch", lang: 'en'},
//   {name: "Chines", lang: 'zh-CN'},
//   {name: "Französisch", lang: 'fr'},
// ]
const changeLang = (lang) => {
  currentLang.value = lang.name
}

const jumpToPage = (menuItem) => {
  if (menuItem.href !== "#") {
    router.push({path: menuItem.href})
  }
}

const dropdownRef = ref(null)
const showDropdown = () => {
  dropdownRef.value?.handleOpen()
}

//点击用户头像
const avatarCommand = (command) => {
  if (command === 'logout') {
    systemStore.logoutApi(router)
  }
}

// 使用 isMobile 和 当前路由来确定菜单如何显示
// 分为两套菜单 DashboardMenu 和 页面的 menu
const isMobile = ref(systemStore.getIsMobile)
const isDashboard = ref(false)

watch(() => systemStore.isMobile, (newValue, oldValue) => {
  isMobile.value = newValue
}, {deep:true})

onMounted(() => {
  console.log("is dashboard: ", useRoute().path)
  if (useRoute().path === "/Dashboard") {
    isDashboard.value = true
  }

  // 手机版点击菜单
  let headerBtn = document.querySelector('.header__btn');
  let headerNav = document.querySelector('.header__nav');
  let header = document.querySelector('.header');

  headerBtn.addEventListener('click', function() {
    headerBtn?.classList.toggle('header__btn--active');

    if(isDashboard.value) {
      systemStore.setMenuIsOpen(!systemStore.getIsOpenMenu)
    }

    if(!isDashboard.value) {
      headerNav.classList.toggle('header__nav--active');
    }

    if (window.scrollY === 0) {
      if (header) header.classList.toggle('header--active');
    }
  });

  window.addEventListener('scroll', function () {
    let header = document.querySelector('.header');
    if (header) {
      if (window.scrollY > 0) {
        header.classList.add('header--active');
      } else {
        header.classList.remove('header--active');
      }
    }

  });
  window.dispatchEvent(new Event('scroll'));


})

</script>

<template>
  <!-- header -->
  <el-row>
    <el-col :span="24">
      <header class="header !tw-w-[100vw]">
        <div class="container">
          <div class="header__content">
        <!-- btn 如果是dashboard 更换掉按钮的功能-->
        <button class="header__btn" type="button" aria-label="header__nav">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <!-- end btn -->

        <!-- logo -->
        <!--            <a href="/" class="header__logo">-->
        <!--              <img src="img/logo.svg" alt="">-->
        <!--            </a>-->
        <a href="/" class="header__logo">
          <img class="!tw-w-[65px] !tw-h-[65px]" :src="systemStore.getWebsite.website_logo">
        </a>
        <!-- end logo -->

        <!-- tagline -->
        <!--            <span class="header__tagline">Arbitrage-Handel <br>HTML-Vorlage</span>-->
            <span class="header__tagline tw-text-[20px] tw-text-white"><a href="/">{{ website.website_name }}</a></span>
        <!-- end tagline -->

        <!-- navigation -->
        <ul class="header__nav" id="header__nav" v-if="!props.onlyShowBottom">
          <li class="header__dropdown" v-for="(item, index) in navigation" :key="index">
            <a v-if="item.child.length > 0" class="dropdown-link" :class="item.name === '...' ? 'dropdown-link--menu':''" href="Javascript:;" @click="jumpToPage(item)" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span v-if="item.name === '...'">
                    <i class="ti ti-dots"></i>
                  </span>
              <span v-else class="!tw-text-[16px]">
                    {{item.name}} <i class="ti ti-point-filled"></i>
                  </span>
            </a>
            <a v-else href="Javascript:;" @click="jumpToPage(item)" class="!tw-text-[16px]" >{{item.name}} </a>

            <template v-if="item.child && item.child.length > 0">
              <ul class="dropdown-menu header__dropdown-menu">
                <li v-for="(child, idx) in item.child" :key="idx">
                  <a href="Javascript:;" @click="jumpToPage(child)" class="!tw-text-[16px]">{{child.name}}</a>
                </li>
              </ul>
            </template>
          </li>

        </ul>
        <!-- end navigation -->

        <!-- language -->
        <div class="header__language">
          <a class="dropdown-link !tw-capitalize notranslate !tw-text-[16px]" translate="no" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{currentLang}} <i class="ti ti-point-filled"></i></a>

          <ul class="dropdown-menu header__language-menu">
            <li :data-google-lang="lang.lang" :lang-name="lang.name" v-for="(lang, index) in systemStore.getLangList" :key="index" @click="changeLang(lang)"><a class="notranslate" translate="no" href="Javascript:;">{{lang.name}}</a></li>
          </ul>
        </div>
        <!-- end language -->

        <!-- profile -->
        <a href="Javascript:;" @click="dashboardOrLogin()" class="header__profile" v-if="!props.onlyShowBottom">
          <i class="ti ti-user-circle"></i>
          <span class="!capitalize"> {{ isLogin? 'Dashboard': 'Login'}}</span>
        </a>
        <!-- end profile -->

        <!-- background -> user header img -->
        <el-dropdown ref="dropdownRef" trigger="click" class="tw-text-white" popper-class="custom-color" v-if="props.onlyShowBottom && userStore.getUserInfo" @command="avatarCommand">
                <span class="el-dropdown-link" @click="showDropdown">
                  <div class="tw-flex tw-justify-start tw-items-center">
                    <el-avatar class="tw-rounded-lg" shape="square" :size="30" :src="userStore.getUserInfo.avatar" />
                    <span class="tw-pl-2 tw-text-white" v-if="!isMobile">{{userStore.getUserInfo.username}}</span>
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </div>
                </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout" class="tw-transition-colors tw-duration-500">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- end  background -> user header img -->

      </div>
        </div>
      </header>
    </el-col>
  </el-row>
  <!-- end header -->
</template>

<style lang="scss">
.custom-color>.el-popper__arrow:before{
  background: $p-border-color !important;
  border: 1px solid $p-border-color !important;
}
.custom-color{
  background: $p-color !important;
  border: 2px solid $p-border-color !important;
}
.el-dropdown-menu {
  background: $p-color !important;

  .el-dropdown-menu__item{
    color: $p-text-color !important;
  }
  .el-dropdown-menu__item:focus{
    background-color: transparent !important;
  }
  .el-dropdown-menu__item:hover{
    background-color: $p-color !important;
    color: $p-text-active-color !important;
  }
}
</style>
